<script lang="ts">
   let className: string = "";
   export { className as class };
   export let style: string = "";
</script>

<svg
   {style}
   class={className}
   viewBox="0 0 24 24"
   fill="none"
   stroke="currentColor"
   stroke-width="2"
   stroke-linecap="round"
   stroke-linejoin="round"
   version="1.1">
   <defs id="defs1372" />
   <polyline
      points="8 12 12 16 16 12"
      id="polyline1364"
      transform="matrix(1.3356497,0,0,1.3356497,-4.3369693,-8.839147)" />
   <line
      x1="11.690825"
      y1="1.8460499"
      x2="11.690825"
      y2="12.531247"
      id="line1366"
      style="stroke-width:2.67131" />
   <circle
      style="opacity:0.999;fill:#fff;fill-opacity:1;stroke:#fff;stroke-width:0.921019;stroke-opacity:1"
      id="path1579"
      cx="11.588515"
      cy="18.870708"
      r="3.0191653" />
</svg>
